<div [formGroup]="form" class="input-grid input-grid-gaps">
    <app-date-input [form]="form" id="validFrom"></app-date-input>
    <app-address-input [form]="form" id="address"></app-address-input>
    <app-text-area-input [form]="form" id="internNote"></app-text-area-input>
</div>
